export const EXTERNAL_APPLICATION_WIDTH = 570;
export const EXTERNAL_APPLICATION_PADDINGTOP = 60;
export const EXTERNAL_APPLICATION_HEIGHTTODECREASE = 150;
export const EXTERNAL_MAX_AVATAR_COUNT = 60;
